import { connect } from 'react-redux'
import { compose, withHandlers, lifecycle, withState, withProps } from 'recompose'
import { bindActionCreators } from 'redux'
import { get } from 'lodash/object'


import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as UserSelectors from 'app/modules/user/selectors'


import SignaturePreview from './component'


const mapStateToProps = state => ({
  currentUser: UserSelectors.currentUser(state),
  orgUsers: UserSelectors.nonBotUsers(state),
  signaturePreviewAllData: PlaybookSelectors.signaturePreviewAllData(state),
  signaturePreviewAllFetchPending: PlaybookSelectors.signaturePreviewAllFetchPending(state),
  signaturePreviewAllFetchFailed: PlaybookSelectors.signaturePreviewAllFetchFailed(state),
})


const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchSignatureMultiBannerPreview: PlaybookActions.fetchSignatureMultiBannerPreview,
    },
    dispatch
  ),
})


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentWillMount() {
      this.props.actions.fetchSignatureMultiBannerPreview({ userId: this.props.currentUser.id, isPlaybookEditor: true })
    },
  }),
  withState('selectedUserId', 'setSelectedUserId', props => props.currentUser.id),
  withHandlers({
    onUserSelect: props => (selected) => {
      const selectedUserId = get(selected, 'value', props.currentUser.id)
      props.actions.fetchSignatureMultiBannerPreview({ userId: selectedUserId, isPlaybookEditor: true })
      props.setSelectedUserId(selectedUserId)
    },
    onRefetchPreviewClick: props => () => {
      props.actions.fetchSignatureMultiBannerPreview({ userId: props.selectedUserId, isPlaybookEditor: true })
    }
  }),
  withProps(props => ({
    selectRandomUser: () => {
      const randomUser = props.orgUsers.toList().get(Math.round(Math.random() * (props.orgUsers.size - 1)))
      props.onUserSelect({ value: randomUser.id })
    }
  })),
)(SignaturePreview)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/SignaturePreview/index.js